import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	fill: "#772583",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M5.25,7.5C3.182,7.5,1.5,5.818,1.5,3.75S3.182,0,5.25,0S9,1.682,9,3.75S7.318,7.5,5.25,7.5z M5.25,1.5 C4.009,1.5,3,2.509,3,3.75S4.009,6,5.25,6S7.5,4.991,7.5,3.75S6.491,1.5,5.25,1.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3,24c-0.387,0-0.708-0.29-0.746-0.675L1.571,16.5H0.75C0.336,16.5,0,16.164,0,15.75v-3C0,9.855,2.355,7.5,5.25,7.5 s5.25,2.355,5.25,5.25v3c0,0.414-0.336,0.75-0.75,0.75H8.929l-0.682,6.825C8.208,23.71,7.887,24,7.5,24H3z M6.821,22.5l0.682-6.825 C7.542,15.29,7.863,15,8.25,15H9v-2.25C9,10.682,7.318,9,5.25,9S1.5,10.682,1.5,12.75V15h0.75c0.387,0,0.708,0.29,0.746,0.675 L3.679,22.5H6.821z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.25,13.5c-3.722,0-6.75-3.028-6.75-6.75S13.528,0,17.25,0C17.664,0,18,0.336,18,0.75S17.664,1.5,17.25,1.5 C14.355,1.5,12,3.855,12,6.75S14.355,12,17.25,12s5.25-2.355,5.25-5.25C22.5,6.336,22.836,6,23.25,6S24,6.336,24,6.75 C24,10.472,20.972,13.5,17.25,13.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.25,8.689c-0.4,0-0.776-0.156-1.059-0.438l-1.721-1.72c-0.292-0.292-0.292-0.768,0-1.061 C14.611,5.328,14.8,5.25,15,5.25s0.388,0.078,0.53,0.219l1.72,1.719l5.469-5.47c0.142-0.142,0.33-0.22,0.53-0.22 s0.389,0.078,0.53,0.22C23.922,1.86,24,2.049,24,2.249s-0.078,0.389-0.22,0.53l-5.47,5.47C18.028,8.532,17.651,8.689,17.25,8.689 C17.251,8.689,17.25,8.689,17.25,8.689z" })
	] })]
});
const ForwardRef = forwardRef(SvgSingleNeutralCheck);
export default ForwardRef;
